import { find, get, toUpper } from "lodash"
import { createSelector } from "reselect"
import { getMostUsedOrDefaultModelId } from "helpers/models"
import { getRawSelectedModelId } from "selectors/queryString"
import { getModels } from "resources/models"

const EMPTY_ARRAY = []

const getPortfolios = state => get(state, "global.data.portfolios.data", EMPTY_ARRAY)
export const getSelectedModel = state => get(state, "modules.homeLayout.selectedModelId")

const getDefaultModel = createSelector(
  [getPortfolios, getModels],
  getMostUsedOrDefaultModelId,
)

const getQueryStringModel = createSelector(
  [getRawSelectedModelId, getModels],
  (rawModelId, models) => {
    const modelId = toUpper(rawModelId)
    // The matched model's own id, not the uppercased URL value: downstream lookups match on `id`.
    return get(find(models, model => toUpper(model.id) === modelId), "id", null)
  },
)

export const getModel = createSelector(
  [getSelectedModel, getDefaultModel],
  (selectedModel, defaultModel) => {
    return selectedModel || defaultModel
  },
)

// For screens that carry their model in the URL (`handle.modelFromUrl`). They reached the profile
// modals through the redux header's `modelId` before; the shell's own sticky selection is another
// route's residue there, and the modals must show the same model as the page.
export const getUrlModel = createSelector(
  [getQueryStringModel, getDefaultModel],
  (queryStringModel, defaultModel) => {
    return queryStringModel || defaultModel
  },
)
